import { render, staticRenderFns } from "./GdprPrivacyOverviewBanner.vue?vue&type=template&id=0d12f8b4&scoped=true"
import script from "./GdprPrivacyOverviewBanner.vue?vue&type=script&lang=js"
export * from "./GdprPrivacyOverviewBanner.vue?vue&type=script&lang=js"
import style0 from "./GdprPrivacyOverviewBanner.vue?vue&type=style&index=0&id=0d12f8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12f8b4",
  null
  
)

export default component.exports